import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-bar-to-up', 'IconArrowBarToUp', [
  ['path', { d: 'M12 10l0 10', key: 'svg-0' }],
  ['path', { d: 'M12 10l4 4', key: 'svg-1' }],
  ['path', { d: 'M12 10l-4 4', key: 'svg-2' }],
  ['path', { d: 'M4 4l16 0', key: 'svg-3' }],
]);
